import {LogoutOutlined, ShoppingOutlined, UserOutlined} from '@ant-design/icons';
import {Avatar, Button, Spin} from 'antd';
import {jwtDecode} from 'jwt-decode';
import {useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {useNavigate} from 'react-router-dom';

import {SessionExpiredModal} from '../../commonComponents/SessionExpiredModal';
import {RQGetUserDetails} from '../../reactQuery/apis';
import {logoutStart} from '../../redux/authAction';
import {selectAuth} from '../../redux/selectors';

import {OrderHistory} from './OrderHistory';
import {PersonalInformation} from './PersonalInformation';

const UserHistory = () => {
  const [activeTab, setActiveTab] = useState('profile');

  const [userId, setUserId] = useState(null);

  const dispatch = useDispatch();

  const navigate = useNavigate();

  const auth = useSelector(selectAuth);

  const token = auth?.tokenData;

  useEffect(() => {
    if (token) {
      try {
        const decoded = jwtDecode(token);
        setUserId(decoded?.userId);
      } catch (err) {
        console.error('Invalid token');
      }
    }
  }, [token]);

  const {data: userData, isLoading, isError} = RQGetUserDetails(userId, token);

  const handleLogout = () => {
    dispatch(logoutStart());
    navigate('/auth/login', {replace:true});
  };

  if (isLoading) {
    return <div className={'flex justify-center items-center'}><Spin /></div>;
  }
  if(isError){
    return <SessionExpiredModal />;
  }

  {return (
    <div className={'w-full flex flex-col justify-center items-center lg:px-20 p-5 lg:mb-20'}>
      <div className={'grid lg:grid-flow-col grid-flow-row lg:grid-cols-3 grid-cols-1 lg:gap-4 max-w-5xl w-full'}>
        <div className={'col-span-1 border border-primary-50 rounded-lg max-h-[400px] w-full mb-3'}>
          <div className={'flex flex-col items-center gap-2 lg:p-5 p-3 mx-auto w-full sticky top-0'}>
            <Avatar size={100} className={'bg-primary-800 text-white mx-auto lg:text7-xl'}>
              {userData?.firstName?.charAt(0).toUpperCase()}
              {userData?.lastName?.charAt(0).toUpperCase()}
            </Avatar>
            <div className={'text-center mt-2'}>
              <h4 className={'font-serif-custom lg:text-xl capitalize'}>
                {userData?.firstName} {userData?.lastName}
              </h4>
              <p className={'text-gray-600 text-sm lg:text-lg mt-2'}>{userData?.email}</p>
              <div className={'flex flex-col justify-center items-center lg:gap-4 gap-2'}>
                <Button
                  onClick={() => setActiveTab('profile')}
                  className={`!bg-white !text-primary-800 lg:w-36 font-semibold mt-3 lg:text-lg flex gap-2 shadow-none ${activeTab === 'profile' ? 'border border-primary-800' : 'border-none'}`}
                >
                  <UserOutlined /> My Profile
                </Button>

                <Button
                  onClick={() => setActiveTab('orders')}
                  className={`!bg-white !text-primary-800 lg:w-36 font-semibold lg:text-lg flex gap-2 shadow-none ${activeTab === 'orders' ? 'border border-primary-800' : 'border-none'}`}
                >
                  <ShoppingOutlined /> My Orders
                </Button>
              </div>
              <Button
                onClick={handleLogout}
                className={'mt-7 mx-auto group lg:w-52 w-48 h-10 text-lg rounded-lg  bg-primary-800 flex items-center justify-center text-white'}
              >
                <LogoutOutlined /> Log Out
              </Button>
            </div>
          </div>
        </div>

        {activeTab === 'profile' && (
          <div className={'col-span-3 border border-primary-50 rounded-lg p-4'}>
            <PersonalInformation />
          </div>
        )}
        {activeTab === 'orders' && (
          <div className={'lg:col-span-3 border border-primary-50 rounded-lg  p-4 w-full'}>
            <h1 className={'text-xl text-primary-900 font-serif-custom p-2 '}>Orders:</h1>
            <OrderHistory />
          </div>
        )}
      </div>
    </div>
  );}
};

export default UserHistory;
